enum RoutePaths {
	ReduxClassic = '/',
	ReduxToolkit = '/reduxtoolkit',
	UseCallbackAndUseMemo = '/usecallback-and-usememo',
}

export default RoutePaths;
